import { createSlice } from '@reduxjs/toolkit';
const navbarBreadcrumbSlice = createSlice({
  name: 'navbarBreadcrumb',
  initialState: {
    label: null,
    path: null
  },
  reducers: {
    setBreadcrumb: (state, action) => {
      state.label = action.payload.label;
      state.path = action.payload.path;
    },
    clearBreadcrumb: state => {
      state.label = null;
      state.path = null;
    }
  }
});
export const {
  setBreadcrumb,
  clearBreadcrumb
} = navbarBreadcrumbSlice.actions;
export default navbarBreadcrumbSlice.reducer;